import {
  FOC_TOUR_LABEL_RES_213RR,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_RES_213RR_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  IOC_CARRYOVER_DISPOSITION,
  focResTourPopoverHtml,
  requirement,
  type FocResTourStepDef,
} from './focResTourTypes';

export const FOC_RES_213RR_TOUR_PARAM = 'focRes213rrTour';
export const FOC_RES_213RR_TOUR_HREF = HREF;
export { focResTourPopoverHtml };

export const FOC_RES_213RR_TOUR_STEPS: FocResTourStepDef[] = [
  {
    id: 'sectionIntro',
    surface: 'requests',
    tour: 'resources-requests',
    title: FOC_TOUR_LABEL_RES_213RR,
    description:
      'ICS 213RR resource requests are routed workflow objects with status visibility through the Coast Guard chain of command—create, review, approve, allocate, and export formal request records.',
  },
  requirement({
    id: 'rs005',
    requirementId: 'US-RS005',
    name: 'Create Resource Request',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'requests',
    tour: 'resources-request-create',
    description:
      'Create a request for resources you need so needs are documented and fulfilled.',
  }),
  requirement({
    id: 'rs006',
    requirementId: 'US-RS006',
    name: 'View My Resource Requests',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'requests',
    tour: 'resources-requests-list',
    description:
      'See pending and completed resource requests so you can track status.',
  }),
  requirement({
    id: 'rs007',
    requirementId: 'US-RS007',
    name: 'Approve/Deny Resource Requests',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'requests',
    tour: 'resources-requests-list',
    description:
      'Users with approval authority review and approve or deny resource requests so resources are allocated properly.',
  }),
  requirement({
    id: 'rs008',
    requirementId: 'US-RS008',
    name: 'Allocate Resources to Requests',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'requests',
    tour: 'resources-requests-list',
    description:
      'Users with allocation authority allocate specific resources to approved requests so needs are filled.',
  }),
  requirement({
    id: 'rs009',
    requirementId: 'US-RS009',
    name: 'Track Resource Request Lifecycle',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'requests',
    tour: 'resources-requests-list',
    description:
      'See the complete lifecycle of a request so you understand progress.',
  }),
  requirement({
    id: 'rs010',
    requirementId: 'US-RS010',
    name: 'Manage ICS-213RR Data and Export',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'requests',
    tour: 'resources-request-create',
    description:
      'Input, view, and edit ICS-213RR fields and export the completed record as an official ICS-213RR document.',
  }),
  requirement({
    id: 'res002',
    requirementId: 'FOC-RES-002',
    name: 'Routed Resource Request Workflow',
    disposition: FOC_REQUIRED_DISPOSITION,
    surface: 'requests',
    tour: 'resources-requests',
    description:
      'Each ICS 213RR is a routed workflow object that can leave the incident workspace, move through the Coast Guard chain of command, and provide persistent status visibility to the requester.',
    bullets: [
      'FOC-RES-002a — Statuses include draft, submitted, awaiting review, approved, denied, returned, routed, forwarded, sourcing, ordered, delayed, filled, partially filled, canceled, closed.',
      'FOC-RES-002b — Chain-of-command routing without bypass; requester sees status, echelon, reviewer, and next action.',
      'FOC-RES-002c — Required-field validation before release; drafts allowed incomplete.',
      'FOC-RES-002d — Qualification typing, kind/type, capability-based, and custom/other requests.',
      'FOC-RES-002e — Reporting locations from facilities, staging, bases, camps, launch sites, or custom locations.',
    ],
  }),
  requirement({
    id: 'res003',
    requirementId: 'FOC-RES-003',
    name: 'Resource Request Finance and Logistics Linkage',
    disposition: FOC_REQUIRED_DISPOSITION,
    surface: 'requests',
    tour: 'resources-requests',
    description:
      'Applicable resource requests link to cost estimate, cost unit, purchase/requisition number, project/funding number, Logistics action, Finance/Admin review, and downstream financial tracking.',
    bullets: [
      'FOC-RES-003a — Cost units such as hourly, daily, weekly, monthly, per person, per item, or other authorized units.',
      'FOC-RES-003b — Authorized Finance/Admin and Logistics users see cost information for burn-rate, funding, procurement, and reimbursement.',
    ],
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_RES_213RR),
  },
];

export function focRes213rrTourNavVisible(enabled: boolean): boolean {
  return enabled;
}

export function focRes213rrTourStepIds(): string[] {
  return FOC_RES_213RR_TOUR_STEPS.map((step) => step.id);
}
